/* @flow */

import React, { Component } from 'react';
import { Dimmer, Segment, Loader, Message, Form } from 'semantic-ui-react';
import * as PagesApi from 'catalog/api/pages';
import VirtualizedSelect from 'react-virtualized-select';

type Props = {
  mode: CatalogRenderingMode,
  block: EditorialGalleryBlock,
  onSerialize?: (block: EditorialGalleryBlock) => void,
  onCanSubmitChanged?: (value: boolean) => void,
};

type State = {
  isFetching: boolean,
  pages: Array<CatalogPage>,
};

const styles = {
  content: {
    minHeight: '120px',
  },
};

const pagesToOptions = pages =>
  pages.map(p => ({
    label: p.name,
    value: p.id,
  }));

class Edit extends Component {
  props: Props;
  state: State;

  constructor(props: Props) {
    super(props);

    this.state = {
      isFetching: false,
      pages: [],
    };
  }

  componentDidMount() {
    this.setState(
      {
        isFetching: true,
      },
      () => this.props.onCanSubmitChanged(false)
    );

    PagesApi.fetchLight(this.props.mode).then(pages =>
      this.setState(
        {
          isFetching: false,
          pages,
        },
        () => this.props.onCanSubmitChanged(true)
      )
    );
  }

  render() {
    const { block, onSerialize } = this.props;
    const { isFetching, pages } = this.state;

    const pageSelected = page =>
      onSerialize({
        ...block,
        pageId: page.value,
        page: {
          id: page.value,
          name: page.label,
        },
      });

    const titleChanged = event =>
      onSerialize({
        ...block,
        title: event.target.value,
      });

    if (isFetching) {
      return (
        <Segment style={styles.content}>
          <Dimmer active inverted>
            <Loader inverted content="Chargement des pages" />
          </Dimmer>
        </Segment>
      );
    }

    const getTitleOrDefault = () => {
      if (typeof block.title !== 'undefined') {
        return block.title;
      }

      return (block.page && block.page.name) || '';
    };

    return (
      <div style={styles.content}>
        <Message
          info
          content="Sélectionnez une page parmi la liste ci-dessous"
        />
        <Form>
          <Form.Field>
            <label>Page cible</label>
            <VirtualizedSelect
              value={block.pageId}
              options={pagesToOptions(pages)}
              placeholder="Sélectionnez une page"
              noResultsText="Aucune page ne correspond aux critères de recherche"
              onChange={pageSelected}
            />
          </Form.Field>
          <Form.Field>
            <label>Libellé du lien</label>
            <input
              value={getTitleOrDefault()}
              onChange={titleChanged}
              placeholder="Libellé du lien"
            />
          </Form.Field>
        </Form>
      </div>
    );
  }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/modules/edito/plugins/page/Edit.js